import { useMutation } from "@tanstack/react-query";
import { useOrg } from "@/hooks/org/useOrg";
import {
  exportScanCsv,
  exportScanJson,
  type ImpactBucket,
} from "@/services/salesforce-release";

function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

interface ExportInput {
  scanId: string;
  filenameBase?: string;
  bucket?: ImpactBucket;
  componentType?: string;
  componentTypes?: string[];
}

/** Fetch + browser-download CSV. */
export function useReleaseReportCsv() {
  const orgId = useOrg().selectedOrg?.id ?? null;
  return useMutation({
    mutationFn: async (input: ExportInput) => {
      const blob = await exportScanCsv(input.scanId, orgId, {
        bucket: input.bucket,
        componentType: input.componentType,
        componentTypes: input.componentTypes,
      });
      const base = input.filenameBase ?? `salesforce-release-impact-${input.scanId.slice(0, 8)}`;
      downloadBlob(blob, `${base}.csv`);
      return true;
    },
  });
}

/** Fetch + browser-download JSON. */
export function useReleaseReportJson() {
  const orgId = useOrg().selectedOrg?.id ?? null;
  return useMutation({
    mutationFn: async (input: ExportInput) => {
      const blob = await exportScanJson(input.scanId, orgId, {
        bucket: input.bucket,
        componentType: input.componentType,
        componentTypes: input.componentTypes,
      });
      const base = input.filenameBase ?? `salesforce-release-impact-${input.scanId.slice(0, 8)}`;
      downloadBlob(blob, `${base}.json`);
      return true;
    },
  });
}
